<template>
    <v-list two-line subheader>
        <v-row align="center">
          <v-col cols="6">
            <div class="body-1 text-left">Citas</div>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-row no-gutters v-show="items.length > 0">
              <v-col cols="12">
                <v-btn-toggle color="secondary" v-model="mode">
                  <v-btn small value="grid">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                  <v-btn small value="list">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col>
                <small>mostrando {{items.length}} de {{total}}</small>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-flex xs12 pa-3 text-center>
            <h1 v-if="!items || items.length === 0" class="caption font-weight-light">No se han encontrado citas.</h1>
        </v-flex>

        <v-layout v-if="mode === 'grid'" wrap>
            <v-flex
                    xs12 md4 lg3 pa-1
                    v-for="item in items"
                    :key="item.id">
                <appointment-card-item
                    :appointment="item"
                    @click:card="appointmentDetails"
                    @click:appointment="newAppointment"
                    @click:cancel="cancel"
                    @click:modify="modify"
                    @click:arrive="arrive"
                />
            </v-flex>
        </v-layout>

        <v-row v-else>
          <v-col cols="12">
            <v-list>
              <template v-for="item in items">
                <appointment-list-item
                    :key="`item-${item.id}`"
                    :appointment="item"
                    @click:card="appointmentDetails"
                    @click:appointment="newAppointment"
                    @click:cancel="cancel"
                    @click:modify="modify"
                    @click:arrive="arrive"
                />
                <v-divider :key="`divider-${item.id}`"></v-divider>
              </template>
            </v-list>
          </v-col>
        </v-row>

        <client-arrive ref="clientArrive" @success="arriveSuccess"/>
        <cancel-appointment ref="cancelAppointment" @success="cancelSuccess"/>
        <payment-edit ref="paymentEditForm" @success="onPaymentUpdated" />

        <client-edit
            :required-fields="requiredFields"
            :requested-fields="requestedFields"
            ref="clientEditForm"
            @success="onClientUpdated"
        />

        <appointment-details-dialog
                ref="detailsDialog"
                :appointment="selectedAppointment"
                @click:edit="onClientEditClick"
                @click:history="showClientHistory"
                @click:edit:payment="onPaymentEditClick"
                @update:status="onStatusUpdated"
        />

      <client-attention-history ref="clientAttentionHistory" />


    </v-list>
</template>

<script>

    import CancelAppointment from '@/components/appointments/CancelAppointment'
    import AppointmentDetailsDialog from '@/components/appointments/details/AppointmentDetailsDialog'
    import ClientArrive from '@/components/appointments/ClientArrive'

    import AppointmentListItem from './AppointmentListItem.vue'
    import AppointmentCardItem from './AppointmentCardItem.vue'
    import ClientEdit from '@/components/appointments/ClientEdit'
    import PaymentEdit from '@/components/payment/PaymentEdit'

    import {mapMutations} from 'vuex'
    import ClientAttentionHistory from "@/components/appointments/attention/ClientAttentionHistory";
    import AppointmentsListMixin from "@/mixins/AppointmentsListMixin";

    export default{
        components: {
          ClientAttentionHistory,
            AppointmentListItem,
            AppointmentCardItem,
            CancelAppointment,
            AppointmentDetailsDialog,
            ClientArrive,
            ClientEdit,
            PaymentEdit,
        },
      mixins: [AppointmentsListMixin],
        props: {
          items: {
            type: Array,
            default: () => []
          },
          total: {
            type: Number,
            default: 0
          }
        },
        data(){
            return {
                mode: 'grid', // grid|list
                loadingActivate: false,
                confirmTitle: '',
                confirmContent: '',
            }
        },
        methods: {
          ...mapMutations(['showSnackBar']),

          onStatusUpdated(scheduleEvent) {
            this.$emit('update:status', scheduleEvent)
          },
          newAppointment(appointment) {
            var vm = this
            vm.$emit('click:appointment', appointment)
          },
          modify(appointment) {
            var vm = this
            vm.$emit('click:modify', appointment)
          },
          cancel(appointment) {
            var vm = this
            vm.$refs.cancelAppointment.show(appointment.id)
          },
          cancelSuccess() {
            var vm = this
            vm.$emit('cancel:success')
          },
          arriveSuccess() {
            var vm = this
            vm.$emit('arrive:success')
          },

        },
        watch: {
            selectedItem(item){
                var vm = this
            },
            items(val){

                var vm = this
                const selectedAppointment = vm.selectedAppointment
                if(!vm.selectedAppointment) return

                const newItemIndex = val.findIndex(item => item.id === selectedAppointment.id)

                if(newItemIndex === -1) return
                vm.selectedAppointment = JSON.parse(JSON.stringify(val[newItemIndex]))

            }
        }
    }
</script>
